import {Utilities} from "src/app/common";

export class Ticket {
  id = null;
  type = null;
  is_private = 0;
  user_id = null;
  subject = null;
  description = null;
  original_file_name = null;
  modified_file_name = null;
  priority = null;
  art = 'Störung';
  tickets_group_id = null;
  ticket_category = null;
  ticket_category_id = null;
  ticket_subcategory = null;
  ticket_subcategory_id = null;
  status = null;
  user=null;
  created_at=null;
  files=null;
  group_name = null;
  assigned_user_id = null;
  assigned_user_name = null;
  updated_at=null;
  screenShots = [];
  is_sync_with_jira = 0;
  jira_issue_id = null;
  jira_status_id = null;
  jira_status_name = null;
  jira_status_category = null;

  static init(ticketDto):Ticket {
    ticketDto.status = ticketDto.status ? { id: ticketDto.status } : null;
    ticketDto.art = ticketDto.art ? { id: ticketDto.art } : null;
    ticketDto.assigned_user_id = ticketDto.assigned_user_id ? { id: ticketDto.assigned_user_id } : null;
    ticketDto.tickets_group_id = ticketDto.tickets_group_id ? { id: ticketDto.tickets_group_id } : null;
    ticketDto.ticket_category_id = ticketDto.ticket_category_id ? { id: ticketDto.ticket_category_id } : null;
    ticketDto.ticket_subcategory_id = ticketDto.ticket_subcategory_id ? { id: ticketDto.ticket_subcategory_id } : null;

    if(ticketDto.files && !Array.isArray(ticketDto.files)) {
      ticketDto.files=JSON.parse(ticketDto.files);
    }

    return Object.assign({},ticketDto);
  }

  static prepare(ticket:Ticket):Ticket {
    var newItem = Object.assign({}, ticket);

    if(Array.isArray(newItem.files)) {
      newItem.files=JSON.stringify(newItem.files);
    }

    return Utilities.getFormatedObject(newItem);
  }

}
